import React from "react";

export default function Icon01() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#E6FAFF" />
      <path
        d="M12 9.33325L10 11.9999V21.3333C10 21.6869 10.1405 22.026 10.3905 22.2761C10.6406 22.5261 10.9797 22.6666 11.3333 22.6666H20.6667C21.0203 22.6666 21.3594 22.5261 21.6095 22.2761C21.8595 22.026 22 21.6869 22 21.3333V11.9999L20 9.33325H12Z"
        stroke="#006980"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6666 14.6667C18.6666 15.374 18.3857 16.0523 17.8856 16.5524C17.3855 17.0525 16.7072 17.3334 16 17.3334C15.2927 17.3334 14.6145 17.0525 14.1144 16.5524C13.6143 16.0523 13.3333 15.374 13.3333 14.6667"
        stroke="#006980"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12H22"
        stroke="#006980"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
